<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <h1>{{i18nMessage.Login}}</h1>
              <p class="text-muted">{{i18nMessage.PleaseLoginToContinue}}</p>
              <div class="text-left">
                <AppForm
                  vo-name="BoMemberLoginVo"
                  @changed="onFormChange"
                />
              </div>
              <CRow>
                <CCol col="6" class="text-left">
                  <CButton 
                    color="primary" 
                    class="px-4"
                    @click="login(user)"
                  >{{i18nMessage.Login}}
                  </CButton>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AppForm from '../../components/AppForm'

export default {
  name: 'Login',
  components: {
    AppForm,
  },
  data () { 
    return {
      user: {},
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
    }),
  },
  methods: {
    ...mapActions({
      login: 'login',
    }),
    onFormChange (data) {
      this.user = {...data}
    },
  },
  mounted () {},
}
</script>
